import { hashHistory } from 'react-router';

// Get 'app' path
import { path as APP_PATH } from '../..';

// All paths
const PATHS = {
  COMPANIES: 'companies',
  INFORMATION: 'information',
};

// Exported paths
export const MAIN_PATH = PATHS.COMPANIES;
export const INFORMATION_PATH = PATHS.INFORMATION;

// Root
const APP_COMPANIES_PATH = `${APP_PATH}/${MAIN_PATH}`;

export const listPath = () => APP_COMPANIES_PATH;
export const navigateToList = () => {
  hashHistory.push(listPath());
};

export const addPath = () => `${APP_COMPANIES_PATH}/add`;
export const navigateToAdd = () => {
  hashHistory.push(addPath());
};

export const showPath = (id) => `${APP_COMPANIES_PATH}/${id}`;
export const navigateToShow = (id) => {
  hashHistory.push(showPath(id));
};



// WEBPACK FOOTER //
// ./routes/app/routes/companies/navigation.js